import { SocialProfileSubType } from '../models/UserStore/NameCard';
import { InstantMessageSubType } from '../models/UserStore/NameCard';

export enum IconType {
  // logo

  Joyajoy = 'Joyajoy',
  JOYAJOYLogoWhite = 'JOYAJOYLogoWhite',
  JOYAJOYAppLogoWhite = 'JOYAJOYAppLogoWhite',
  JoyajoyIcon = 'JoyajoyIcon',
  JOYAJOYHeaderLogo = 'JOYAJOYHeaderLogo',
  JOYAJOYxWEAColumn = 'JOYAJOYxWEAColumn',
  JOYAJOYxWEARow = 'JOYAJOYxWEARow',
  JOYAJOYNameLogo = 'JOYAJOYNameLogo',

  AmCham = 'AmCham',
  TTPM = 'TTPM',
  HKCT = 'HKCT',
  PCCW = 'PCCW',

  // tts-enhancement
  TTSBanner = 'TTSBanner',
  TTSPic01 = 'TTSPic01',
  TTSPic02 = 'TTSPic02',
  TTSPic03 = 'TTSPic03',
  TTSPic04 = 'TTSPic04',
  TTSPic05 = 'TTSPic05',
  TTSPic06 = 'TTSPic06',
  CreateGameContent = 'CreateGameContent',

  // common
  Certified = 'Certified',
  Email = 'Email',
  Password = 'Password',
  Gamified = 'Gamified',
  Cross = 'Cross',
  Tick = 'Tick',
  EmptyTick = 'EmptyTick',
  Classroom = 'Classroom',
  Copy = 'Copy',
  NameCard = 'NameCard',
  AINameCard = 'AINameCard',
  ESGValue = 'ESGValue',
  TransferOwner = 'TransferOwner',
  Notice = 'Notice',
  Referral = 'Referral',
  ReferralWhite = 'ReferralWhite',
  SearchWhite = 'SearchWhite',
  EmptySquare = 'EmptySquare',
  GreenTick = 'GreenTick',
  HyperLink = 'HyperLink',
  Telephone = 'Telephone',
  Period = 'Period',
  LocationIndicator = 'LocationIndicator',
  Post = 'Post',
  ReportProblem = 'ReportProblem',
  Folder = 'Folder',
  Language = 'Language',
  TimeLeft = 'TimeLeft',
  Group = 'Group',
  CircleCompetition = 'CircleCompetition',
  PictureProblemWhite = 'PictureProblemWhite',
  Conversation = 'Conversation',
  Guarantee = 'Guarantee',
  WebsiteReferral = 'WebsiteReferral',
  CustomizeGame = 'CustomizeGame',
  Brainx9 = 'Brainx9',
  SettingDisplayName = 'SettingDisplayName',
  SettingUsername = 'SettingUsername',
  Earth = 'Earth',

  ClassroomLine = 'ClassroomLine',
  AlbumLine = 'AlbumLine',
  GameLine = 'GameLine',
  PostLine = 'PostLine',
  ParticipantLine = 'ParticipantLine',
  GameInstructionLine = 'GameInstructionLine',

  //Space Type
  SocialSpace = 'SocialSpace',
  MembershipSpace = 'MembershipSpace',
  FanSpace = 'FanSpace',
  PromotionSpace = 'PromotionSpace',
  InteractiveLearningSpace = 'InteractiveLearningSpace',
  TeamworkSpace = 'TeamworkSpace',
  DailyCourseSpace = 'DailyCourseSpace',
  CourseSpace = 'CourseSpace',
  PrayerSpace = 'PrayerSpace',
  CorporateSpace = 'CorporateSpace',
  SelfStudySpace = 'SelfStudySpace',
  CompetitionSpace = 'CompetitionSpace',
  AssessmentSpace = 'AssessmentSpace',

  //ProfilePicture
  ProfilePic1 = 'ProfilePic1',
  ProfilePic2 = 'ProfilePic2',
  ProfilePic3 = 'ProfilePic3',
  ProfilePic4 = 'ProfilePic4',
  ProfilePic5 = 'ProfilePic5',
  ProfilePic6 = 'ProfilePic6',
  ProfilePic7 = 'ProfilePic7',
  ProfilePic8 = 'ProfilePic8',
  ProfilePic9 = 'ProfilePic9',
  ProfilePic10 = 'ProfilePic10',
  ProfilePic11 = 'ProfilePic11',

  // social profile
  SocialProfileJOYAJOY = 'SocialProfileJOYAJOY',
  SocialProfileFacebook = 'SocialProfileFacebook',
  SocialProfileInstagram = 'SocialProfileInstagram',
  SocialProfileLinkedin = 'SocialProfileLinkedin',
  SocialProfileWeibo = 'SocialProfileWeibo',
  SocialProfileYoutube = 'SocialProfileYoutube',

  // instant message
  InstantMessageSkype = 'InstantMessageSkype',
  InstantMessageWechat = 'InstantMessageWechat',
  InstantMessageWhatsApp = 'InstantMessageWhatsApp',
  InstantMessageGoogleChat = 'InstantMessageGoogleChat',
  InstantMessageICQ = 'InstantMessageICQ',
  InstantMessageJabber = 'InstantMessageJabber',
  InstantMessageLine = 'InstantMessageLine',
  InstantMessageQQ = 'InstantMessageQQ',

  // balance
  Credit = 'Credit',
  SpaceCreditFrame = 'SpaceCreditFrame',
  SocialExp = 'SocialExp',
  KnowledgeExp = 'KnowledgeExp',

  //game/ show
  Game = 'Game',
  SlideShow = 'SlideShow',

  // game-type
  GameTypeDictation = 'GameTypeDictation',
  GameTypeRecitation = 'GameTypeRecitation',
  GameTypeLyricsDictation = 'GameTypeLyricsDictation',
  GameTypeLyrics = 'GameTypeLyrics',
  GameTypeLyricsSpeak = 'GameTypeLyricsSpeak',
  GameTypeSentenceRestructure = 'GameTypeSentenceRestructure',
  GameTypeSentenceRestructureListening = 'GameTypeSentenceRestructureListening',
  GameTypeFingerWritingAdv = 'GameTypeFingerWritingAdv',
  GameTypeFingerWritingComponent = 'GameTypeFingerWritingComponent',
  GameTypeFingerWriting = 'GameTypeFingerWriting',
  GameTypeFingerWritingDictation = 'GameTypeFingerWritingDictation',
  GameTypeSpellingBig = 'GameTypeSpellingBig',
  GameTypeListening = 'GameTypeListening',
  GameTypeSequence = 'GameTypeSequence',
  GameTypeWordMatching = 'GameTypeWordMatching',
  GameTypeMultipleChoice = 'GameTypeMultipleChoice',
  GameTypeFillBlankSpelling = 'GameTypeFillBlankSpelling',
  GameTypeFillBlankWords = 'GameTypeFillBlankWords',
  GameTypeDialogsConversation = 'GameTypeDialogsConversation',
  GameTypeSpeakingListen = 'GameTypeSpeakingListen',
  GameTypeSpeakingRead = 'GameTypeSpeakingRead',
  GameTypeSpeakingRecite = 'GameTypeSpeakingRecite',
  GameTypeFingWritingInkless = 'GameTypeFingWritingInkless',
  GameTypeFingerWritingStroke = 'GameTypeFingerWritingStroke',
  MultiplayerGameTypeJoyachess = 'MultiplayerGameTypeJoyachess',
  MultiplayerGameTypeFiveLoavesTwoFish = 'MultiplayerGameTypeFiveLoavesTwoFish',
  MultiplayerGameTypeTicTacToe = 'MultiplayerGameTypeTicTacToe',
  MultiplayerGameTypeGomoku = 'MultiplayerGameTypeGomoku',
  GameModeNameChess = 'GameModeNameChess',
  GameTypeJoyAPassage = 'GameTypeJoyAPassage',
  GameTypeFastSpeaking = 'GameTypeFastSpeaking',
  GameTypeSpellSyllable = 'GameTypeSpellSyllable',
  TutorGame = 'TutorGame',
}

//logo
import TTPMLogo from '../assets/graphics/jpeg/TTPM.jpeg';
import AmChamLogo from '../assets/graphics/jpeg/TheAmericanChamberOfCommerceHK.jpg';
import JOYAJOYAppLogoWhite from '../assets/graphics/png/icons/logo/JOYAJOY_logo_ai_2023_App_1Colour_White_2x.png';
import JOYAJOYLogoWhite from '../assets/graphics/png/icons/logo/JOYAJOY_logo_ai_2023_White.png';
import HKCTLogo from '../assets/graphics/png/intro/HKCT_AWARD2023_LOGO.png';
import PCCWLogo from '../assets/graphics/png/intro/PCCW.png';
import JoyAJoyIcon from '../assets/graphics/svg/icons/dipdipcup_gameplay_score_icon.svg';

import JoyajoyLogo from '../assets/graphics/svg/logos/logo_joyAjoy.svg';
import JOYAJOYHeaderLogo from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_WebUse.png';
import JOYAJOYxWEAColumnLogo from '../assets/graphics/png/icons/logo/JOYAJOY-WEA_Logo_01.png';
import JOYAJOYxWEARowLogo from '../assets/graphics/png/icons/logo/JOYAJOY-WEA_Logo_02.png';
import JOYAJOYNameLogo from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2022_Text_WhiteStroke.png';

import TTSBanner from '../assets/graphics/jpeg/tts-enhancement/TTSEnhancementGuideBanner.jpg';
import TTSPic01 from '../assets/graphics/jpeg/tts-enhancement/ScreenShot_01.jpg';
import TTSPic02 from '../assets/graphics/jpeg/tts-enhancement/ScreenShot_02.jpg';
import TTSPic03 from '../assets/graphics/jpeg/tts-enhancement/ScreenShot_03.jpg';
import TTSPic04 from '../assets/graphics/jpeg/tts-enhancement/ScreenShot_04.jpg';
import TTSPic05 from '../assets/graphics/jpeg/tts-enhancement/ScreenShot_05.jpg';
import TTSPic06 from '../assets/graphics/jpeg/tts-enhancement/ScreenShot_06.jpg';
import CreateGameContentPng from '../assets/graphics/png/games/For_web_icon_content_game.png';

//common
import TimeLeftIcon from '../assets/graphics/png/icons/common/cloud_icon_time_left_2x.png';
import GroupIcon from '../assets/graphics/png/icons/common/cloud_icon_groups_2x.png';
import CircleCompetitionIcon from '../assets/graphics/png/icons/common/notification_icon_competition_2x.png';
import ReferralIcon from '../assets/graphics/png/icons/common/cloud_icon_referral_1x.png';
import ReferralWhiteIcon from '../assets/graphics/png/icons/colorable/cloud_icon_referral_line_2x.png';
import ESGValueIcon from '../assets/graphics/png/icons/common/Value_ESG_2x.png';
import AINameCardIcon from '../assets/graphics/png/icons/common/cloud_icon_ainamecard_2x.png';
import CopyIcon from '../assets/graphics/svg/icons/cloud_icon_copy_line.svg';
import HyperLinkIcon from '../assets/graphics/png/icons/common/cloud_icon_hyperlink_2x.png';
import LocationIndicatorIcon from '../assets/graphics/png/icons/common/cloud_icon_locationIndicator_2x.png';
import NameCardIcon from '../assets/graphics/png/icons/common/cloud_icon_namecard_2x.png';
import PostIcon from '../assets/graphics/png/icons/common/cloud_icon_post_2x.png';
import ReportProblemIcon from '../assets/graphics/svg/icons/cloud_icon_report_problem_line.svg';
import ConversationIcon from '../assets/graphics/png/icons/common/icon_JOYAJOY_Website_Conversion.png';
import GuaranteeIcon from '../assets/graphics/png/icons/common/icon_JOYAJOY_Website_Guarantee.png';
import WebsiteReferralIcon from '../assets/graphics/png/icons/common/icon_JOYAJOY_Website_Referral.png';
import CustomizeGameIcon from '../assets/graphics/png/icons/common/icon_JOYAJOY_Website_UserCustomizeGame.png';

import TransferOwnerIcon from '../assets/graphics/png/icons/common/cloud_icon_transferOwnership_2x.png';
import PeriodIcon from '../assets/graphics/png/icons/common/report_icon_period_2x.png';
import TelephoneIcon from '../assets/graphics/png/icons/common/setting_page_icon_telephone_2x.png';
import GamifiedIcon from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Horizontal_Logo_Slogan_ForDarkBG.png';
import SearchWhiteIcon from '../assets/graphics/svg/colorable/cloud_icon_search_white.svg';
import CertifiedIcon from '../assets/graphics/svg/icons/cloud_icon_certified_line.svg';
import CrossIcon from '../assets/graphics/svg/icons/cloud_icon_circle_cross.svg';
import TickIcon from '../assets/graphics/svg/icons/cloud_icon_confirm_ddgreen.svg';
import ClassroomIcon from '../assets/graphics/svg/icons/cloud_icon_classroom_upgraded.svg';
import FolderIcon from '../assets/graphics/svg/icons/cloud_icon_folder.svg';
import NoticeIcon from '../assets/graphics/svg/icons/cloud_icon_notice.svg';
import EmptySquareIcon from '../assets/graphics/svg/icons/cloud_icon_select_empty.svg';
import LanguageIcon from '../assets/graphics/svg/icons/cloud_icon_subject_language.svg';
import GreenTickIcon from '../assets/graphics/svg/icons/cloud_icon_tick.svg';
import EmptyTickIcon from '../assets/graphics/svg/icons/language_button_empty.svg';
import EmailIcon from '../assets/graphics/svg/icons/setting_page_icon_email_line.svg';
import PasswordIcon from '../assets/graphics/svg/icons/cloud_icon_lock_line.svg';
import Brainx9Icon from '../assets/graphics/png/icons/cloud_icon_memory_game_brain_line_2x.png';
import SettingDisplayNameIcon from '../assets/graphics/png/icons/setting_page_icon_displayname_line_2x.png';
import SettingUsernameIcon from '../assets/graphics/png/icons/setting_page_icon_username_line_2x.png';
import EarthIcon from '../assets/graphics/png/icons/cloud_icon_region_line_2x.png';
//Line Version
import PictureProblemWhiteIcon from '../assets/graphics/svg/icons/cloud_icon_pictureProblem_line_2x.png';
import ClassroomLineIcon from '../assets/graphics/svg/icons/cloud_icon_classroom_line.svg';
import AlbumLineIcon from '../assets/graphics/svg/icons/cloud_icon_game_Set_album_line.svg';
import GameLineIcon from '../assets/graphics/svg/icons/cloud_icon_games_line.svg';
import PostLineIcon from '../assets/graphics/svg/icons/cloud_icon_post_line.svg';
import ParticipantLineIcon from '../assets/graphics/svg/icons/Game_participant_line.svg';
import GameInstructionLineIcon from '../assets/graphics/png/icons/colorable/Game_information_line_2x.png';

//game/show
import SlideShowIcon from '../assets/graphics/svg/icons/cloud_but_tutorial_line_2x.png';
import GameIcon from '../assets/graphics/svg/icons/cloud_icon_games.svg';

//Space Type
import InteractiveLearningIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_GeneralLearning.svg';
import AssessmentIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_assessment.svg';
import CompetitionIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_competition.svg';
import CorporateIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_corporateTrain.svg';
import CourseIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_course.svg';
import DailyCourseIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_courseDaily.svg';
import FanIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_fans.svg';
import SocialSpaceIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_interactive.svg';
import MembershipIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_membership.svg';
import PromotionIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_promoteMkt.svg';
import PrayerIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_religious.svg';
import SelfStudyIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_self.svg';
import TeamworkIcon from '../assets/graphics/svg/icons/space-type/cloud_icon_classroom_teamwork.svg';

//profile-pic
import ProfilePic1 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_01.svg';
import ProfilePic2 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_02.svg';
import ProfilePic3 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_03.svg';
import ProfilePic4 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_04.svg';
import ProfilePic5 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_05.svg';
import ProfilePic6 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_06.svg';
import ProfilePic7 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_07.svg';
import ProfilePic8 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_08.svg';
import ProfilePic9 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_09.svg';
import ProfilePic10 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_10.svg';
import ProfilePic11 from '../assets/graphics/svg/profile-image/setting_page_icon_profile_image_empty_11.svg';

// social profile
import SocialProfileJOYAJOY from '../assets/graphics/png/icons/socialProfile/dipdipcup_gameplay_score_icon_2x.png';
import SocialProfileFacebook from '../assets/graphics/png/icons/socialProfile/icon_login_facebook_color_2x.png';
import SocialProfileInstagram from '../assets/graphics/png/icons/socialProfile/icon_login_instagram_color_2x.png';
import SocialProfileLinkedin from '../assets/graphics/png/icons/socialProfile/icon_login_linkedin_color_2x.png';
import SocialProfileWeibo from '../assets/graphics/png/icons/socialProfile/icon_login_weibo_color_2x.png';
import SocialProfileYoutube from '../assets/graphics/png/icons/socialProfile/icon_login_youtube_color_2x.png';

// instant message
import InstantMessageGoogleChat from '../assets/graphics/png/icons/instantMessage/icon_login_googlechat_color_2x.png';
import InstantMessageICQ from '../assets/graphics/png/icons/instantMessage/icon_login_icq_color_2x.png';
import InstantMessageJabber from '../assets/graphics/png/icons/instantMessage/icon_login_jabber_color_2x.png';
import InstantMessageLine from '../assets/graphics/png/icons/instantMessage/icon_login_line_color_2x.png';
import InstantMessageQQ from '../assets/graphics/png/icons/instantMessage/icon_login_qq_color_2x.png';
import InstantMessageSkype from '../assets/graphics/png/icons/instantMessage/icon_login_skype_color_2x.png';
import InstantMessageWechat from '../assets/graphics/png/icons/instantMessage/icon_login_wechat_colorv2_2x.png';
import InstantMessageWhatsApp from '../assets/graphics/png/icons/instantMessage/icon_login_whatsapp_color_2x.png';

// balance
import CreditIcon from '../assets/graphics/svg/icons/rewards_icon_cash_credit.svg';
import SpaceCreditFrameIcon from '../assets/graphics/png/icons/assets/space_credit_frame.png';
import SocialExpIcon from '../assets/graphics/png/icons/assets/cloud_icon_social_2x.png';
import KnowledgeExpIcon from '../assets/graphics/png/icons/assets/cloud_icon_knowledge_2x.png';

//game type
import GameTypeDictationLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_dictation_line_2x.png';
import GameTypeRecitationLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_recitation_line_2x.png';
import GameTypeLyricsDictationLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_lyrics_dictation_line_2x.png';
import GameTypeLyricsLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_lyrics_line_2x.png';
import GameTypeLyricsSpeakLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_lyrics_speak_line_2x.png';
import GameTypeSentenceRestructureLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_sentence_restructure_line_2x.png';
import GameTypeSentenceRestructureListeningLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_jumbled_sentence_listen_line_2x.png';
import GameTypeFingerWritingAdvLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_finger_writing_adv_line_2x.png';
import GameTypeFingerWritingComponentLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_finger_writing_component_line_2x.png';
import GameTypeFingerWritingLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_finger_writing_line_2x.png';
import GameTypeFingerWritingDictationLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_finger_writing_dictation_line_2x.png';
import GameTypeSpellingBigLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_spelling_line_2x.png';
import GameTypeListeningLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_listening_line_2x.png';
import GameTypeSequenceLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_sequence_line_2x.png';
import GameTypeWordMatchingLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_word_matching_line_2x.png';
import GameTypeMultipleChoiceLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_multiple_choice_line_2x.png';
import GameTypeFillBlankSpellingLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_fill_blank_spelling_line_2x.png';
import GameTypeFillBlankWordsLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_fill_blank_words_line_2x.png';
import GameTypeDialogsConversationLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_dialogs_conversation_line_2x.png';
import GameTypeSpeakingListenLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_speaking_listen_line_2x.png';
import GameTypeSpeakingReadLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_speaking_read_line_2x.png';
import GameTypeSpeakingReciteLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_conversation_ai_rating_line_2x.png';
import GameTypeFingWritingInklessLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_finger_writing_inkless_line_2x.png';
import GameTypeFingerWritingStrokeLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_finger_writing_stroke_line_2x.png';
import MultiplayerGameTypeJoyachessLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_joychess_line_2x.png';
import MultiplayerGameTypeFiveLoavesTwoFishLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_5_loaves_2_fish_line_2x.png';
import MultiplayerGameTypeTicTacToeLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_tic_tac_toe_line_2x.png';
import MultiplayerGameTypeGomokuLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_gomoku_line_2x.png';
import GameModeNameChessLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_mode_nameChess_line_2x.png';
import GameTypeJoyAPassageLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_JOYApassage_line_2x.png';
import GameTypeFastSpeakingLogo from '../assets/graphics/svg/icons/game-type/GameTypeFastSpeaking.png';
import GameTypeSpellSyllableLogo from '../assets/graphics/svg/icons/game-type/cloud_icon_game_type_syllable_line_2x.png';
import TutorGameLogo from '../assets/graphics/png/icons/colorable/cloud_icon_tutor_games_line_2x.png';

export const Icons: Record<IconType, string> = {
  // game type
  [IconType.GameTypeDictation]: GameTypeDictationLogo,
  [IconType.GameTypeRecitation]: GameTypeRecitationLogo,
  [IconType.GameTypeLyricsDictation]: GameTypeLyricsDictationLogo,
  [IconType.GameTypeLyrics]: GameTypeLyricsLogo,
  [IconType.GameTypeLyricsSpeak]: GameTypeLyricsSpeakLogo,
  [IconType.GameTypeSentenceRestructure]: GameTypeSentenceRestructureLogo,
  [IconType.GameTypeSentenceRestructureListening]:
    GameTypeSentenceRestructureListeningLogo,
  [IconType.GameTypeFingerWritingAdv]: GameTypeFingerWritingAdvLogo,
  [IconType.GameTypeFingerWritingComponent]: GameTypeFingerWritingComponentLogo,
  [IconType.GameTypeFingerWriting]: GameTypeFingerWritingLogo,
  [IconType.GameTypeFingerWritingDictation]: GameTypeFingerWritingDictationLogo,
  [IconType.GameTypeSpellingBig]: GameTypeSpellingBigLogo,
  [IconType.GameTypeListening]: GameTypeListeningLogo,
  [IconType.GameTypeSequence]: GameTypeSequenceLogo,
  [IconType.GameTypeWordMatching]: GameTypeWordMatchingLogo,
  [IconType.GameTypeMultipleChoice]: GameTypeMultipleChoiceLogo,
  [IconType.GameTypeFillBlankSpelling]: GameTypeFillBlankSpellingLogo,
  [IconType.GameTypeFillBlankWords]: GameTypeFillBlankWordsLogo,
  [IconType.GameTypeDialogsConversation]: GameTypeDialogsConversationLogo,
  [IconType.GameTypeSpeakingListen]: GameTypeSpeakingListenLogo,
  [IconType.GameTypeSpeakingRead]: GameTypeSpeakingReadLogo,
  [IconType.GameTypeSpeakingRecite]: GameTypeSpeakingReciteLogo,
  [IconType.GameTypeFingWritingInkless]: GameTypeFingWritingInklessLogo,
  [IconType.GameTypeFingerWritingStroke]: GameTypeFingerWritingStrokeLogo,
  [IconType.MultiplayerGameTypeJoyachess]: MultiplayerGameTypeJoyachessLogo,
  [IconType.MultiplayerGameTypeFiveLoavesTwoFish]:
    MultiplayerGameTypeFiveLoavesTwoFishLogo,
  [IconType.MultiplayerGameTypeTicTacToe]: MultiplayerGameTypeTicTacToeLogo,
  [IconType.MultiplayerGameTypeGomoku]: MultiplayerGameTypeGomokuLogo,
  [IconType.GameModeNameChess]: GameModeNameChessLogo,
  [IconType.GameTypeJoyAPassage]: GameTypeJoyAPassageLogo,
  [IconType.GameTypeFastSpeaking]: GameTypeFastSpeakingLogo,
  [IconType.GameTypeSpellSyllable]: GameTypeSpellSyllableLogo,
  [IconType.TutorGame]: TutorGameLogo,

  // logo
  [IconType.Joyajoy]: JoyajoyLogo,
  [IconType.JOYAJOYLogoWhite]: JOYAJOYLogoWhite,
  [IconType.JOYAJOYAppLogoWhite]: JOYAJOYAppLogoWhite,
  [IconType.JoyajoyIcon]: JoyAJoyIcon,
  [IconType.JOYAJOYHeaderLogo]: JOYAJOYHeaderLogo,
  [IconType.JOYAJOYxWEAColumn]: JOYAJOYxWEAColumnLogo,
  [IconType.JOYAJOYxWEARow]: JOYAJOYxWEARowLogo,
  [IconType.JOYAJOYNameLogo]: JOYAJOYNameLogo,
  [IconType.AmCham]: AmChamLogo,
  [IconType.TTPM]: TTPMLogo,
  [IconType.HKCT]: HKCTLogo,
  [IconType.PCCW]: PCCWLogo,

  // tts-enhancement
  [IconType.TTSBanner]: TTSBanner,
  [IconType.TTSPic01]: TTSPic01,
  [IconType.TTSPic02]: TTSPic02,
  [IconType.TTSPic03]: TTSPic03,
  [IconType.TTSPic04]: TTSPic04,
  [IconType.TTSPic05]: TTSPic05,
  [IconType.TTSPic06]: TTSPic06,
  [IconType.CreateGameContent]: CreateGameContentPng,

  //common
  [IconType.TimeLeft]: TimeLeftIcon,
  [IconType.Group]: GroupIcon,
  [IconType.CircleCompetition]: CircleCompetitionIcon,
  [IconType.PictureProblemWhite]: PictureProblemWhiteIcon,
  [IconType.Email]: EmailIcon,
  [IconType.Password]: PasswordIcon,
  [IconType.Certified]: CertifiedIcon,
  [IconType.Gamified]: GamifiedIcon,
  [IconType.Copy]: CopyIcon,
  [IconType.NameCard]: NameCardIcon,
  [IconType.AINameCard]: AINameCardIcon,
  [IconType.ESGValue]: ESGValueIcon,
  [IconType.TransferOwner]: TransferOwnerIcon,
  [IconType.Cross]: CrossIcon,
  [IconType.Tick]: TickIcon,
  [IconType.EmptyTick]: EmptyTickIcon,
  [IconType.Classroom]: ClassroomIcon,
  [IconType.Notice]: NoticeIcon,
  [IconType.Referral]: ReferralIcon,
  [IconType.ReferralWhite]: ReferralWhiteIcon,
  [IconType.SearchWhite]: SearchWhiteIcon,
  [IconType.EmptySquare]: EmptySquareIcon,
  [IconType.GreenTick]: GreenTickIcon,
  [IconType.HyperLink]: HyperLinkIcon,
  [IconType.Telephone]: TelephoneIcon,
  [IconType.Period]: PeriodIcon,
  [IconType.LocationIndicator]: LocationIndicatorIcon,
  [IconType.Post]: PostIcon,
  [IconType.ReportProblem]: ReportProblemIcon,
  [IconType.Folder]: FolderIcon,
  [IconType.Language]: LanguageIcon,
  [IconType.Conversation]: ConversationIcon,
  [IconType.Guarantee]: GuaranteeIcon,
  [IconType.WebsiteReferral]: WebsiteReferralIcon,
  [IconType.CustomizeGame]: CustomizeGameIcon,
  [IconType.Brainx9]: Brainx9Icon,
  [IconType.SettingDisplayName]: SettingDisplayNameIcon,
  [IconType.SettingUsername]: SettingUsernameIcon,
  [IconType.Earth]: EarthIcon,

  //Line Version
  [IconType.ClassroomLine]: ClassroomLineIcon,
  [IconType.AlbumLine]: AlbumLineIcon,
  [IconType.GameLine]: GameLineIcon,
  [IconType.PostLine]: PostLineIcon,
  [IconType.ParticipantLine]: ParticipantLineIcon,
  [IconType.GameInstructionLine]: GameInstructionLineIcon,

  //Space Type
  [IconType.SocialSpace]: SocialSpaceIcon,
  [IconType.MembershipSpace]: MembershipIcon,
  [IconType.FanSpace]: FanIcon,
  [IconType.PromotionSpace]: PromotionIcon,
  [IconType.InteractiveLearningSpace]: InteractiveLearningIcon,
  [IconType.TeamworkSpace]: TeamworkIcon,
  [IconType.DailyCourseSpace]: DailyCourseIcon,
  [IconType.CourseSpace]: CourseIcon,
  [IconType.PrayerSpace]: PrayerIcon,
  [IconType.CorporateSpace]: CorporateIcon,
  [IconType.SelfStudySpace]: SelfStudyIcon,
  [IconType.CompetitionSpace]: CompetitionIcon,
  [IconType.AssessmentSpace]: AssessmentIcon,

  //ProfilePicture
  [IconType.ProfilePic1]: ProfilePic1,
  [IconType.ProfilePic2]: ProfilePic2,
  [IconType.ProfilePic3]: ProfilePic3,
  [IconType.ProfilePic4]: ProfilePic4,
  [IconType.ProfilePic5]: ProfilePic5,
  [IconType.ProfilePic6]: ProfilePic6,
  [IconType.ProfilePic7]: ProfilePic7,
  [IconType.ProfilePic8]: ProfilePic8,
  [IconType.ProfilePic9]: ProfilePic9,
  [IconType.ProfilePic10]: ProfilePic10,
  [IconType.ProfilePic11]: ProfilePic11,

  // social profile
  [IconType.SocialProfileJOYAJOY]: SocialProfileJOYAJOY,
  [IconType.SocialProfileFacebook]: SocialProfileFacebook,
  [IconType.SocialProfileInstagram]: SocialProfileInstagram,
  [IconType.SocialProfileLinkedin]: SocialProfileLinkedin,
  [IconType.SocialProfileWeibo]: SocialProfileWeibo,
  [IconType.SocialProfileYoutube]: SocialProfileYoutube,

  // social profile
  [IconType.InstantMessageSkype]: InstantMessageSkype,
  [IconType.InstantMessageWechat]: InstantMessageWechat,
  [IconType.InstantMessageWhatsApp]: InstantMessageWhatsApp,
  [IconType.InstantMessageGoogleChat]: InstantMessageGoogleChat,
  [IconType.InstantMessageICQ]: InstantMessageICQ,
  [IconType.InstantMessageJabber]: InstantMessageJabber,
  [IconType.InstantMessageLine]: InstantMessageLine,
  [IconType.InstantMessageQQ]: InstantMessageQQ,

  // balance
  [IconType.Credit]: CreditIcon,
  [IconType.SpaceCreditFrame]: SpaceCreditFrameIcon,
  [IconType.SocialExp]: SocialExpIcon,
  [IconType.KnowledgeExp]: KnowledgeExpIcon,

  //game/show
  [IconType.Game]: GameIcon,
  [IconType.SlideShow]: SlideShowIcon,
};

// Icons Sets
export const InstantMessageIconMap: Record<InstantMessageSubType, IconType> = {
  [InstantMessageSubType.WhatsApp]: IconType.InstantMessageWhatsApp,
  [InstantMessageSubType.Skype]: IconType.InstantMessageSkype,
  [InstantMessageSubType.Facebook]: IconType.SocialProfileFacebook,
  [InstantMessageSubType.QQ]: IconType.InstantMessageQQ,
  [InstantMessageSubType.ICQ]: IconType.InstantMessageICQ,
  [InstantMessageSubType.Jabber]: IconType.InstantMessageJabber,
  [InstantMessageSubType.Line]: IconType.InstantMessageLine,
  [InstantMessageSubType.WeChat]: IconType.InstantMessageWechat,
  [InstantMessageSubType.GoogleChat]: IconType.InstantMessageGoogleChat,
  [InstantMessageSubType.Custom]: IconType.SocialProfileJOYAJOY, // TODO: update icon
};

export const SocialProfileIconMap: Record<SocialProfileSubType, IconType> = {
  [SocialProfileSubType.JOYAJOY]: IconType.SocialProfileJOYAJOY,
  [SocialProfileSubType.Facebook]: IconType.SocialProfileFacebook,
  [SocialProfileSubType.Instagram]: IconType.SocialProfileInstagram,
  [SocialProfileSubType.Youtube]: IconType.SocialProfileYoutube,
  [SocialProfileSubType.Linkedin]: IconType.SocialProfileLinkedin,
  [SocialProfileSubType.SinaWeibo]: IconType.SocialProfileWeibo,
  [SocialProfileSubType.Custom]: IconType.SocialProfileJOYAJOY, // TODO: update icon
};

// MARK: moved to gameTypeDetails
// export const GameIconTags = Object.freeze<Record<string, IconType>>({
//   notFound: IconType.PictureProblemWhite,
//   show: IconType.SlideShow,
//   dictation: IconType.GameTypeDictation,
//   recitation: IconType.GameTypeRecitation,
//   lyricsDictation: IconType.GameTypeLyricsDictation,
//   lyricsRecitation: IconType.GameTypeLyrics,
//   lyricsSpeaking: IconType.GameTypeLyricsSpeak,
//   jumbledSentence: IconType.GameTypeSentenceRestructure,
//   jumbledSentenceListening: IconType.GameTypeSentenceRestructureListening,
//   fingerWritingAdvance: IconType.GameTypeFingerWritingAdv,
//   fingerWritingComponent: IconType.GameTypeFingerWritingComponent,
//   fingerWriting: IconType.GameTypeFingerWriting,
//   fingerWritingDictation: IconType.GameTypeFingerWritingDictation,
//   spelling: IconType.GameTypeSpellingBig,
//   listening: IconType.GameTypeListening,
//   ordering: IconType.GameTypeSequence,
//   matching: IconType.GameTypeWordMatching,
//   multipleChoice: IconType.GameTypeMultipleChoice,
//   fillInTheBlanksBySpelling: IconType.GameTypeFillBlankSpelling,
//   fillInTheBlanksByWord: IconType.GameTypeFillBlankWords,
//   conversation: IconType.GameTypeDialogsConversation,
//   followMeToSpeak: IconType.GameTypeSpeakingListen,
//   readAloud: IconType.GameTypeSpeakingRead,
//   readAloudRecite: IconType.GameTypeSpeakingRecite,
//   fingerWritingInkless: IconType.GameTypeFingWritingInkless,
//   fingerWritingStroke: IconType.GameTypeFingerWritingStroke,
//   joyachess: IconType.MultiplayerGameTypeJoyachess,
//   fiveLoavesTwoFish: IconType.MultiplayerGameTypeFiveLoavesTwoFish,
//   ticTacToe: IconType.MultiplayerGameTypeTicTacToe,
//   gomoku: IconType.MultiplayerGameTypeGomoku,
//   joyachessSingle: IconType.MultiplayerGameTypeJoyachess,
//   joyachessTeam: IconType.MultiplayerGameTypeJoyachess,
//   joyachessPersonalName: IconType.GameModeNameChess,
//   joyachessTeamName: IconType.GameModeNameChess,
//   joyaPassage: IconType.GameTypeJoyAPassage,
//   speaking: IconType.GameTypeFastSpeaking,
//   syllable: IconType.GameTypeSpellSyllable,
// });
